export default "__VITE_ASSET__bafpyagP__"